import { EmployeeDeviceSubscriptions } from '../../../../../../components/EmployeeSubscriptions/EmployeeDeviceSubscriptions.js';
import { EmployeeSubscriptionsLayout } from '../../../../../../components/EmployeeSubscriptions/EmployeeSubscriptionsLayout.js';
import { SubscriptionCategory } from '../../../../../../common/enums.js';
import {
  employeeDevicesSubtitleMsg,
  myDevicesAndSubscriptionsMsg,
  myDevicesMsg,
  omaElisaForEmployeeMsg,
  t,
} from '../../../../../../common/i18n/index.js';
import {
  getEmployeeSubscriptions,
  loadCompanyInfo,
  loadVirtualCatalogs,
} from '../../../../../../selfservice/actions/index.js';
import { paths } from '../../../../../../common/constants/pathVariables.js';
import { useAuth } from '../../../../AuthProvider.js';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

export const DevicesPath = () => {
  const dispatch = useDispatch();
  const { authenticatedUser } = useAuth();

  useEffect(() => {
    if (authenticatedUser?.businessId) {
      dispatch(loadCompanyInfo());
      dispatch(loadVirtualCatalogs());
      dispatch(getEmployeeSubscriptions(SubscriptionCategory.DEVICE));
    }
  }, [dispatch, authenticatedUser?.businessId]);

  return (
    <EmployeeSubscriptionsLayout
      breadCrumbs={[
        { name: t.H6JV(omaElisaForEmployeeMsg), path: paths.EMPLOYEE_HOME },
        { name: t.YRZJ(myDevicesAndSubscriptionsMsg), path: paths.EMPLOYEE_DEVICES },
        { name: t.NP53(myDevicesMsg) },
      ]}
      title={t.NP53(myDevicesMsg)}
      subtitle={t.AE4T(employeeDevicesSubtitleMsg)}
    >
      <EmployeeDeviceSubscriptions />
    </EmployeeSubscriptionsLayout>
  );
};
